import LoadingPlaceholder from "../../../components/LoadingPlaceholder";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import React, {useState} from "react";
import TableBody from "@material-ui/core/TableBody";
import EATableActionButton from "../../../components/tableComponents/EATableActionButton";
import {Link} from "react-router-dom";
import {calculateBescheidLink} from "../../../initialObjects/BescheidObjects";
import {formatDate} from "../../../utils/DateUtils";
import EASimpleTableHead from "../../../components/tableComponents/EASimpleTableHead";
import Paper from "@material-ui/core/Paper";
import {userHasAnyRole} from "../../../utils/SecurityUtils";
import {
    BEAUFTRAGTER,
    BETREIBER,
    FACHADMIN,
    SYSTEMADMIN, ZUST_SBA,
    ZUST_SBB,
    ZUST_SBD,
    ZUST_SBS
} from "../../../consts/funktionaleRollen";

const BescheidTableRow = ({bescheid}) => {
    const [isHover, setIsHover] = useState(false);

    const handleMouseEnter = () => setIsHover(true);
    const handleMouseLeave = () => setIsHover(false);

    const isHoveredStyle = {
        backgroundColor: "rgba(0, 0, 0, 0.04)"
    };

    const upperRowCellStyle = {
        borderBottom: "none"
    };

    const editAllowed = () => {
        return userHasAnyRole([SYSTEMADMIN, FACHADMIN]);
    }

    return (
        <>
            <TableRow style={isHover ? isHoveredStyle : {}} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                <TableCell style={upperRowCellStyle}>
                    <div className="eatabwrapper">
                        {editAllowed() && (
                            <EATableActionButton iconName="ico-edit">
                                <Link to={calculateBescheidLink(bescheid, "modus=s")}/>
                            </EATableActionButton>
                        )}
                        <EATableActionButton iconName="ico-view">
                            <Link to={calculateBescheidLink(bescheid)}/>
                        </EATableActionButton>
                    </div>
                </TableCell>
                <TableCell style={upperRowCellStyle}>
                    {bescheid.bescheidQualitaet?.value}
                </TableCell>
                <TableCell style={upperRowCellStyle}>
                    {bescheid.bescheidart?.value}
                </TableCell>
                <TableCell style={upperRowCellStyle}>
                    {bescheid.behoerde?.bezeichnung}
                </TableCell>
                <TableCell style={upperRowCellStyle}>
                    {bescheid.aktenzeichen}
                </TableCell>
                <TableCell style={upperRowCellStyle}>
                    {bescheid.bescheidsstatus?.value}
                </TableCell>
                <TableCell style={upperRowCellStyle}>
                    {formatDate(bescheid.bescheidsdatum)}
                </TableCell>
                <TableCell style={upperRowCellStyle}>
                    {formatDate(bescheid.ablaufdatum)}
                </TableCell>
            </TableRow>
            <TableRow style={isHover ? isHoveredStyle : {}} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                <TableCell>
                </TableCell>
                <TableCell colSpan={8}>
                    {bescheid.bemerkung}
                </TableCell>
            </TableRow>
        </>
    );
}

export default function BescheidUebersichtTable({data, loading}) {
    const columns = ["", "Bescheidqualität", "Bescheidart", "Behörde", "Aktenzeichen", "Status", "Bescheiddatum", "Ablaufdatum"];

    return (
        <Paper>
            {loading && <LoadingPlaceholder/>}
            {!loading &&
                <TableContainer>
                    <Table size={"small"}>
                        <EASimpleTableHead className="tableHead" columns={columns}>
                            <TableCell>
                            </TableCell>
                            <TableCell>
                                Bescheidqualität
                            </TableCell>
                            <TableCell>
                                Bescheidart
                            </TableCell>
                            <TableCell>
                                Behörde
                            </TableCell>
                            <TableCell>
                                Aktenzeichen
                            </TableCell>
                            <TableCell>
                                Status
                            </TableCell>
                            <TableCell>
                                Bescheiddatum
                            </TableCell>
                            <TableCell>
                                Ablaufdatum
                            </TableCell>
                        </EASimpleTableHead>
                        <TableBody>
                            {data.map(bescheid => <BescheidTableRow key={bescheid.id} bescheid={bescheid}/>)}
                        </TableBody>
                    </Table>
                </TableContainer>}
        </Paper>
    );
}
